import { PLATFORM_LOGO } from '../lib/brand';

/** Platform mark — a plain img so downscaling stays sharp. */
export function PlatformLogo({ size = 36 }: { size?: number }) {
  return <img src={PLATFORM_LOGO} alt="FormTags" width={size} height={size} decoding="async" style={{ display: 'block', objectFit: 'contain', flexShrink: 0 }} />;
}
